

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Partner extends Vue {
  @Prop() private msg!: string;

  userFlow = [
    {
      image: 'logo.png',
    },
    {
      image: 'logo.png',
    },
    {
      image: 'logo.png',
    },
    {
      image: 'logo.png',
    },
    {
      image: 'logo.png',
    },
    {
      image: 'logo.png',
    },
  ]
}
